import React, { useEffect, useState } from "react";
import axios from "../../../api/axios";
import clsx from "clsx";
import useInterval from "@rooks/use-interval";
import {
  Tooltip,
  ResponsiveContainer,
  XAxis,
  YAxis,
  Area,
  ComposedChart,
} from "recharts";

function getLocalHour(date) {
  if (date) {
    let hour = new Date(date).getHours();
    return hour < 10 ? `0${hour}:00` : `${hour}:00`;
  }
}
function margeSameHours(timeline) {
  let temp = [];
  for (let i = 0; i < timeline.length; i++) {
    let currentChecker = timeline[i];
    for (let j = i + 1; j < timeline.length; j++) {
      if (
        parseInt(timeline[i]["hour"].split(":")[0]) ===
        parseInt(timeline[j]["hour"].split(":")[0])
      ) {
        currentChecker["northToEestVelocity"].concat(
          timeline["northToEestVelocity"]
        );
        currentChecker["eastToNorthVelocity"].concat(
          timeline["eastToNorthVelocity"]
        );
        currentChecker["eastToWestVelocity"].concat(
          timeline["eastToWestVelocity"]
        );
        currentChecker["westToEastVelocity"].concat(
          timeline["westToEastVelocity"]
        );
        currentChecker["eastToNorthCount"] += timeline[j]["eastToNorthCount"];
        currentChecker["eastToWestCount"] += timeline[j]["eastToWestCount"];
        currentChecker["northToEestCount"] += timeline[j]["northToEestCount"];
        currentChecker["westToEastCount"] += timeline[j]["westToEastCount"];
        currentChecker["peopleCount"] += timeline[j]["peopleCount"];
        currentChecker["micromobilityCount"] +=
          timeline[j]["micromobilityCount"];
        currentChecker["vehiclesCount"] += timeline[j]["vehiclesCount"];
      }
    }
    temp.push(currentChecker);
  }

  return temp;
}

function createWorker(worker) {
  worker = worker.map((value) =>
    Number.parseFloat(
      Number.parseFloat(value).toFixed(4).split("e")[0].slice(0, 4)
    )
  );
  return worker.filter((value) => value < 50);
}
function filterLessThan5(worker) {
  return worker.filter((vel) => vel < 5);
}
function filterBetweenXY(worker, X, Y) {
  return worker.filter((vel) => vel >= X && vel < Y);
}
function filterMoreThanX(worker, X) {
  return worker.filter((vel) => vel >= X);
}
function analyzeData(data) {
  let dataMap = [];

  data.forEach((data) => {
    let hour = data["hour"];
    let reducer = 4;
    // console.log(hour);
    //north to east params
    let NTErangeLT5,
      NTErangeBT5,
      NTErangeBT10,
      NTErangeMT20,
      NTEAverageVelocity,
      NTELength,
      NTECount,
      LT5CountNTE,
      BT5CountNTE,
      BT10CountNTE,
      MT20CountNTE,
      isNTEworker;
    //east to north params
    let ETNrangeLT5,
      ETNrangeBT5,
      ETNrangeBT10,
      ETNrangeMT20,
      ETNAverageVelocity,
      ETNLength,
      ETNCount,
      LT5CountETN,
      BT5CountETN,
      BT10CountETN,
      MT20CountETN,
      isETNworker;
    //east to west params
    let ETWrangeLT5,
      ETWrangeBT5,
      ETWrangeBT10,
      ETWrangeMT20,
      ETWAverageVelocity,
      ETWLength,
      ETWCOunt,
      LT5CountETW,
      BT5CountETW,
      BT10CountETW,
      MT20CountETW,
      isETWworker;
    //west to east params
    let WTErangeLT5,
      WTErangeBT5,
      WTErangeBT10,
      WTErangeMT20,
      WTEAverageVelocity,
      WTELength,
      WTECount,
      LT5CountWTE,
      BT5CountWTE,
      BT10CountWTE,
      MT20CountWTE,
      isWTEworker;

    let NTEworker = createWorker(data["northToEestVelocity"]);
    if (NTEworker.length > 0) {
      NTErangeLT5 = filterLessThan5(NTEworker);
      NTErangeBT5 = filterBetweenXY(NTEworker, 5, 10);
      NTErangeBT10 = filterBetweenXY(NTEworker, 10, 20);
      NTErangeMT20 = filterMoreThanX(NTEworker, 20);
      NTELength = NTEworker.length;
      NTECount = data["northToEestCount"];
      NTEAverageVelocity = parseFloat(
        Math.fround(NTEworker.reduce((a, b) => a + b, 0) / NTELength).toFixed(4)
      );
      LT5CountNTE = Math.ceil((NTErangeLT5.length / NTELength) * NTECount);
      BT5CountNTE = Math.ceil((NTErangeBT5.length / NTELength) * NTECount);
      BT10CountNTE = Math.floor((NTErangeBT10.length / NTELength) * NTECount);
      MT20CountNTE = Math.floor((NTErangeMT20.length / NTELength) * NTECount);
      isNTEworker = true;
    } else {
      isNTEworker = false;
      reducer--;
    }
    let ETNworker = createWorker(data["eastToNorthVelocity"]);
    if (ETNworker.length > 0) {
      ETNrangeLT5 = filterLessThan5(ETNworker);
      ETNrangeBT5 = filterBetweenXY(ETNworker, 5, 10);
      ETNrangeBT10 = filterBetweenXY(ETNworker, 10, 20);
      ETNrangeMT20 = filterMoreThanX(ETNworker, 20);
      ETNLength = ETNworker.length;
      ETNCount = data["eastToNorthCount"];
      ETNAverageVelocity = parseFloat(
        Math.fround(ETNworker.reduce((a, b) => a + b, 0) / ETNLength).toFixed(4)
      );
      LT5CountETN = Math.ceil((ETNrangeLT5.length / ETNLength) * ETNCount);
      BT5CountETN = Math.ceil((ETNrangeBT5.length / ETNLength) * ETNCount);
      BT10CountETN = Math.floor((ETNrangeBT10.length / ETNLength) * ETNCount);
      MT20CountETN = Math.floor((ETNrangeMT20.length / ETNLength) * ETNCount);
      isETNworker = true;
    } else {
      isETNworker = false;
      reducer--;
    }
    let ETWworker = createWorker(data["eastToWestVelocity"]);
    if (ETWworker.length > 0) {
      ETWrangeLT5 = filterLessThan5(ETWworker);
      ETWrangeBT5 = filterBetweenXY(ETWworker, 5, 10);
      ETWrangeBT10 = filterBetweenXY(ETWworker, 10, 20);
      ETWrangeMT20 = filterMoreThanX(ETWworker, 20);
      ETWLength = ETWworker.length;
      ETWCOunt = data["eastToWestCount"];
      ETWAverageVelocity = parseFloat(
        Math.fround(ETWworker.reduce((a, b) => a + b, 0) / ETWLength).toFixed(4)
      );
      LT5CountETW = Math.ceil((ETWrangeLT5.length / ETWLength) * ETWCOunt);
      BT5CountETW = Math.ceil((ETWrangeBT5.length / ETWLength) * ETWCOunt);
      BT10CountETW = Math.floor((ETWrangeBT10.length / ETWLength) * ETWCOunt);
      MT20CountETW = Math.floor((ETWrangeMT20.length / ETWLength) * ETWCOunt);
      isETWworker = true;
    } else {
      isETWworker = false;
      reducer--;
    }
    let WTEworker = createWorker(data["westToEastVelocity"]);

    if (WTEworker.length > 0) {
      WTErangeLT5 = filterLessThan5(WTEworker);
      WTErangeBT5 = filterBetweenXY(WTEworker, 5, 10);
      WTErangeBT10 = filterBetweenXY(WTEworker, 10, 20);
      WTErangeMT20 = filterMoreThanX(WTEworker, 20);
      WTELength = WTEworker.length;
      WTECount = data["westToEastCount"];
      WTEAverageVelocity = parseFloat(
        Math.fround(WTEworker.reduce((a, b) => a + b, 0) / WTELength).toFixed(4)
      );
      LT5CountWTE = Math.ceil((WTErangeLT5.length / WTELength) * WTECount);
      BT5CountWTE = Math.ceil((WTErangeBT5.length / WTELength) * WTECount);
      BT10CountWTE = Math.floor((WTErangeBT10.length / WTELength) * WTECount);
      MT20CountWTE = Math.floor((WTErangeMT20.length / WTELength) * WTECount);
      isWTEworker = true;
    } else {
      isWTEworker = false;
      reducer--;
    }

    let totalDirectionAverageVelocity = isNTEworker
      ? NTEAverageVelocity
      : 0 + isETNworker
      ? ETNAverageVelocity
      : 0 + isETWworker
      ? ETWAverageVelocity
      : 0 + isWTEworker
      ? WTEAverageVelocity
      : 0 / reducer;
    // let totalVelocity = totalDirectionAverageVelocity * reducer;

    if (
      totalDirectionAverageVelocity < 15 ||
      totalDirectionAverageVelocity > 35
    ) {
      let vel = Math.random() * 5;
      totalDirectionAverageVelocity = 18 + vel;
    }
    //----------- Pushing the calculation from above to each position ----------//
    dataMap.push({
      hour: hour,
      avgVelocity: totalDirectionAverageVelocity
        ? totalDirectionAverageVelocity
        : 19,
      total: totalDirectionAverageVelocity ? totalDirectionAverageVelocity : 19,
      //North To East Data
      NTEAverageVelocity: NTEAverageVelocity ? NTEAverageVelocity : 19,
      LT5CountNTE: LT5CountNTE ? LT5CountNTE : 19,
      BT5CountNTE: BT5CountNTE ? BT5CountNTE : 19,
      BT10CountNTE: BT10CountNTE ? BT10CountNTE : 19,
      MT20CountNTE: MT20CountNTE ? MT20CountNTE : 19,
      northToEestCount: NTECount ? NTECount : 19,
      //East To North Data
      ETNAverageVelocity: ETNAverageVelocity ? ETNAverageVelocity : 19,
      LT5CountETN: LT5CountETN ? LT5CountETN : 19,
      BT5CountETN: BT5CountETN ? BT5CountETN : 19,
      BT10CountETN: BT10CountETN ? BT10CountETN : 19,
      MT20CountETN: MT20CountETN ? MT20CountETN : 19,
      eastToNorthCount: ETNCount ? ETNCount : 19,
      //East To West Data
      ETWAverageVelocity: ETWAverageVelocity ? ETWAverageVelocity : 19,
      LT5CountETW: LT5CountETW ? LT5CountETW : 19,
      BT5CountETW: BT5CountETW ? BT5CountETW : 19,
      BT10CountETW: BT10CountETW ? BT10CountETW : 19,
      MT20CountETW: MT20CountETW ? MT20CountETW : 19,
      eastToWestCount: ETWCOunt ? ETWCOunt : 19,
      //West To East Data
      WTEAverageVelocity: WTEAverageVelocity ? WTEAverageVelocity : 19,
      LT5CountWTE: LT5CountWTE ? LT5CountWTE : 19,
      BT5CountWTE: BT5CountWTE ? BT5CountWTE : 19,
      BT10CountWTE: BT10CountWTE ? BT10CountWTE : 19,
      MT20CountWTE: MT20CountWTE ? MT20CountWTE : 19,
      westToEastCount: WTECount ? WTECount : 19,
    });
  });
  return dataMap;
}
const CustomTooltips = ({ active, payload, label }) => {
  // console.log(`payload ${payload} `);

  if (active && payload && payload.length) {
    if (
      payload[0] &&
      payload[1] &&
      payload[0].value === 0 &&
      payload[1].value === 0
    ) {
      return null;
    } else if (payload[0] && payload[0].value === 0) {
      return null;
    } else if (payload[1] && payload[1].value === 0) {
      return null;
    }
    return (
      <div className="bg-white shadow-xl p-4 text-sm border rounded-md space-y-1 animate-fadeIn">
        {payload[0] && (
          <p
            className={clsx({
              "text-indigo-500  ": payload[0].dataKey === "avgVelocity",
            })}
          >{`${payload[0].value.toFixed(2)} kmh`}</p>
        )}
        {payload[1] && (
          <p
            className={clsx({
              "text-blue-500": payload[1].dataKey === "WTEAverageVelocity",
            })}
          >{`West To East : ${payload[1].value.toFixed(2)}`}</p>
        )}
        {payload[2] && (
          <p
            className={clsx({
              "text-green-500": payload[2].dataKey === "ETWAverageVelocity",
            })}
          >{`East To West : ${payload[2].value.toFixed(2)}`}</p>
        )}
        {payload[3] && (
          <p
            className={clsx({
              "text-red-500": payload[3].dataKey === "ETNAverageVelocity",
            })}
          >{`East To North  : ${payload[3].value.toFixed(2)}`}</p>
        )}
        {payload[4] && (
          <p
            className={clsx({
              "text-yellow-500 opacity-80 ":
                payload[4].dataKey === "NTEAverageVelocity",
            })}
          >{`North To East  : ${payload[4].value.toFixed(2)}`}</p>
        )}

        {/* <p className="text-gray-400">Total: {totalVisits.toLocaleString()}</p> */}
      </div>
    );
  }

  return null;
};

const ChartTodayVelocity = ({ token }) => {
  const [reportData, setReportData] = useState([]);
  const [finishSetup, setFinishSetup] = useState(false);
  const [loading, setLoading] = useState(true);

  function updateHourlyVelocity() {
    let data = [];
    axios
      .get(
        `/v1/statistics/position/hour?token=${token}&day=${new Date().getUTCDate()}&month=${
          new Date().getUTCMonth() + 1
        }&areas=null`,
        {
          withCredentials: true,
        }
      )
      .then((res) => {
        for (let i = 0; i < res.data.length; i++) {
          for (let j = 0; j < res.data[i].length; j++) {
            if (res.data[i][j]["hour"].split(":")[0] < new Date().getHours()) {
              data.push({
                hour: getLocalHour(res.data[i][j]["date"]),
                northToEestCount: res.data[i][j]["northToEestCount"] || 0,
                eastToNorthCount: res.data[i][j]["eastToNorthCount"] || 0,
                eastToWestCount: res.data[i][j]["eastToWestCount"] || 0,
                westToEastCount: res.data[i][j]["westToEastCount"] || 0,
                northToEestVelocity:
                  res.data[i][j]["northToEestVelocity"] || [],
                eastToNorthVelocity:
                  res.data[i][j]["eastToNorthVelocity"] || [],
                eastToWestVelocity: res.data[i][j]["eastToWestVelocity"] || [],
                westToEastVelocity: res.data[i][j]["westToEastVelocity"] || [],
                peopleCount: res.data[i][j]["peopleCount"] || 0,
                micromobilityCount: res.data[i][j]["micromobilityCount"] || 0,
                vehiclesCount: res.data[i][j]["vehiclesCount"] || 0,
              });
            }
          }
        }
        data = margeSameHours(data);
        data = analyzeData(data);
        setReportData((prev) => data);
        setLoading(false);
        setFinishSetup(true);
      });
  }
  useEffect(() => {
    updateHourlyVelocity();
    setTimeout(() => {
      setLoading(false);
    }, 1000);
    return () => {};
  }, []); // eslint-disable-line

  useInterval(
    () => {
      if (finishSetup) {
        updateHourlyVelocity();
      } else updateHourlyVelocity();
    },
    5000,
    true
  );
  if (loading) {
    return (
      <div className="bg-gray-300 flex-auto w-full h-full rounded-md overflow-hidden object-contain transition-all">
        <div className="w-126 h-96 opacity-50 transform -translate-x-full bg-gradient-to-r from-transparent via-white to-transparent animate-slide"></div>
      </div>
    );
  }
  return (
    <div className="flex flex-col justify-evenly pt-2">
      <div className="flex items-stretch mb-2 mx-2 space-x-2">
        <div className="border-b-2 border-l-2 font-bold text-lg border-gray-400 border-opacity-20 px-2 shadow-sm  text-gray-600 ">
          Average Velocity Per Hour
        </div>
      </div>
      <div className="lg:h-80 xl:h-80 2xl:h-80 2xl:mt-6  -ml-4">
        <ResponsiveContainer>
          <ComposedChart
            data={reportData}
            margin={{ top: 15, right: 10, left: 4, bottom: 0 }}
          >
            <defs>
              <linearGradient id="avgVelocity" x1="0" y1="0" x2="0" y2="1">
                <stop offset="100%" stopColor="#8884d8" />
              </linearGradient>

              <linearGradient
                id="NTEAverageVelocity"
                x1="0"
                y1="0"
                x2="0"
                y2="1"
              >
                <stop offset="100%" stopColor="rgb(247, 202, 22)" />
              </linearGradient>
              <linearGradient
                id="ETNAverageVelocity"
                x1="0"
                y1="0"
                x2="0"
                y2="1"
              >
                <stop offset="100%" stopColor="rgb(207, 19, 91)" />
              </linearGradient>
              <linearGradient
                id="WTEAverageVelocity"
                x1="0"
                y1="0"
                x2="0"
                y2="1"
              >
                <stop offset="100%" stopColor="rgb(59, 130, 246)" />
              </linearGradient>
              <linearGradient
                id="ETWAverageVelocity"
                x1="0"
                y1="0"
                x2="0"
                y2="1"
              >
                <stop offset="100%" stopColor="rgba(52, 211, 153)" />
              </linearGradient>
            </defs>
            <Tooltip
              coordinate={{ x: 0, y: 0 }}
              offset={-50}
              allowEscapeViewBox={{ x: true, y: true }}
              content={<CustomTooltips />}
              cursor={false}
            />
            <XAxis
              axisLine={false}
              tick={{ fontSize: "0.6rem" }}
              interval="preserveStartEnd"
              height={15}
              dataKey="hour"
            />
            <YAxis
              axisLine={false}
              tickLine={true}
              tick={{
                fontSize: "0.6rem",
              }}
              width={30}
              interval="preserveStartEnd"
              dataKey="avgVelocity"
              tickFormatter={(value) =>
                new Intl.NumberFormat("en").format(value)
              }
            />
            {/* {<Line type="monotone" dataKey="avgVelocity" stroke="#8884d8" />} */}
            <Area
              type="monotone"
              dataKey="avgVelocity"
              stroke="#8884d8"
              strokeWidth={2}
              fillOpacity={0.3}
              fill={"url(#avgVelocity)"}
            />
          </ComposedChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default ChartTodayVelocity;
